import {ClientBrowsingHistoryConvertResponse} from "../../infra/api/service/client_browsing_history_api_convert";
import {FrontDate} from "./frontDate";

export class ClientBrowsingHistory {
    public static from(from: ClientBrowsingHistoryConvertResponse): ClientBrowsingHistory {
        return new ClientBrowsingHistory(
            from.clientID,
            from.customerID,
            from.createdAt,
        )
    }

    constructor(public readonly clientID: string,
                public readonly customerID: string,
                public readonly createdAt: FrontDate,) {

    }
}


// WEBPACK FOOTER //
// ./src/domain/model/client_browsing_history.ts